// extracted by mini-css-extract-plugin
module.exports = {"container":"Member_container__3LK9A","name":"Member_name__2lUhf","active":"Member_active__3xgho","alternate":"Member_alternate__3TIUV"};